import { BlockquoteBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpBlockquoteBlock } from './AmpBlockquoteBlock';
import { BlockquoteBlock } from './BlockquoteBlock';

export const BlockquoteBlockMapping: BlockMapping<BlockquoteBlockData> = {
  invariant: [
    {
      prop: 'quote',
      msg: 'Quote required for blockquote',
    },
  ],
  width: 'NARROW',
  Component: BlockquoteBlock,
  AmpComponent: AmpBlockquoteBlock,
};
